import { parseUrlQuery } from '../../services/utils';

import axios from 'axios';
import {
	API_URL,
	API_KEY
} from '../../config';

// create a new instance of axios for the SSP API
const noraApi = axios.create( { baseURL: API_URL } );

// set default headers for all requests to the sspApi
noraApi.defaults.headers[ 'Content-Type' ] = 'application/json';
// eslint-disable-next-line camelcase
noraApi.defaults.headers.api_key = API_KEY;

const { now } = parseUrlQuery( window.location.search );

if ( now ) {
	// eslint-disable-next-line camelcase
	noraApi.defaults.headers.application_now = now;
}

// this runs before each request is sent to the API
noraApi.interceptors.request.use(
	request => {
		// look for the token in sessionStorage
		const token = sessionStorage.getItem( 'token' ) || null;

		// if a token is found, add it to the request header
		if ( token ) {
			Object.assign( request.headers, { AccessToken: token } );
		}

		return request;
	},
	error => Promise.reject( error )
);

// this runs whenever a request is recieved from the api
noraApi.interceptors.response.use(
	response => {
		// get the token from the response header
		const token = response.headers.refreshtoken;

		// if a token is found, store it in sessionStorage
		if ( token ) {
			sessionStorage.setItem( 'token', token );
			sessionStorage.setItem( 'warningTime', new Date().getTime() + 60000 * 10 );
		}

		return response;
	},
	error => Promise.reject( error )
);

// helper function for requests to the nora API
export const noraApiRequest = async ( {
	method = 'GET',
	url,
	params = {},
	data = {},
	headers = {},
	...rest
} ) => {
	const response = await noraApi( {
		method,
		url,
		params,
		data,
		headers,
		...rest
	} );

	return response;
};

export default noraApi;
